import { cloneDeep } from "lodash";

import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { CAYUSE_TYPES } from "globals/constants";

function getParsedRuleWithOptions (question, ruleAnswer) {
	const itemToSelect = question.items?.findIndex(item => item.text === ruleAnswer);
	const item = question.items?.find(item => item.text === ruleAnswer);
	const itemText = item?.text || ruleAnswer;

	return { ...question, itemToSelect, itemText };
}

function getParsedRule (question, ruleAnswer) {
	const itemId = ruleAnswer;
	return { ...question, itemId};
}

export const findDisplayRulesByValues = (displayRules, questions) => {
	let selectedDisplayRulesList = [];

	for (const ruleSet of displayRules) {
		let tempRuleSet = [];
		for (const rule of ruleSet) {
			const cleanRule = rule.replace(/.toString\(\)|.length| > 0|'|\s/g, "").trim();
			for (const question of questions) {
				const value = removeBracketFromQuestionId(question.value);

				if (cleanRule.includes("==")) {
					const [ ruleType, ruleAnswer ] = getOptionsAnswerAndType(rule);
					if (ruleType === value && isNonEmptyArray(question.items)) {
						tempRuleSet.push(getParsedRuleWithOptions(question, ruleAnswer));
					}
				} else if (cleanRule.includes("[")) {
					let [ ruleType, ruleAnswer ] = getNestedAnswerAndType(rule);
					if (ruleType === value && isNonEmptyArray(question.items)) {
						tempRuleSet.push(getParsedRuleWithOptions(question, ruleAnswer));
					}
				} else if ((CAYUSE_TYPES.FUNDING_PROGRAM === question.cayuseType || CAYUSE_TYPES.CLASSIFICATION_CODES === question.cayuseType)
					&& cleanRule.includes("includes")) {
					let [ ruleType, ruleAnswer ] = getIncludeAnswerAndType(rule);
					if (ruleType === value) {
						tempRuleSet.push(getParsedRule(question, ruleAnswer));
					}
				} else if (cleanRule.includes("flw.remove.nulls")
					&& (CAYUSE_TYPES.FUNDING_PROGRAM === question.cayuseType || question.cayuseType === CAYUSE_TYPES.CLASSIFICATION_CODES)
					&& cleanRule.includes(value)
				) {
					tempRuleSet.push(question);
				} else if (cleanRule === value) {
					tempRuleSet.push(question);
				} else if ([CAYUSE_TYPES.ORG_FINDER, CAYUSE_TYPES.UNIT_FINDER,
					CAYUSE_TYPES.PERSON_FINDER].includes(question.cayuseType) &&
					cleanRule.includes(".") && value === cleanRule.split(".")[0]) {
					tempRuleSet.push(extractItemIdFromRule(cleanRule, question));
				}
			}
		}
		selectedDisplayRulesList.push(tempRuleSet);
	}

	return selectedDisplayRulesList;
};

// converts "testQuestion == 'testAnswer'" => ["testQuestion", "testAnswer"]
const getOptionsAnswerAndType = rule => {
	const [ ruleType, ruleAnswer ] = rule.split("==");

	return [ ruleType.trim(), ruleAnswer.replaceAll("'", "").trim() ];
};

// converts "testQuestion['testAnswer']" => ["testQuestion", "testAnswer"]
const getNestedAnswerAndType = rule => {
	const [ ruleType, ruleAnswer ] = rule.split("[");

	return [ ruleType.trim(), ruleAnswer.replace("]", "").replaceAll("'", "").trim() ];
};

const getIncludeAnswerAndType = rule => {
	const includesIndex = rule.indexOf('includes(');
	const openParenIndex = rule.indexOf('(', includesIndex);
	const closeParenIndex = rule.indexOf(')', includesIndex);
	const includesContent = rule.substring(openParenIndex + 1, closeParenIndex).replaceAll("'", "");

	const match = rule.match(/mapAttr\(([^,]*)/);
	const valueBetweenMapAttrAndId = match ? match[1] : '';
	return [ valueBetweenMapAttrAndId.trim(), includesContent.trim()];
};

const removeBracketFromQuestionId = questionId =>
	isNonEmptyString(questionId) && questionId.includes("{{")
		? questionId
			.replace(/{{/, " ")
			.replace(/}}/, " ")
			.trim()
		: "";

export const getListOfValueFromDisplayRules = visibleField => {
	let parsedRules = [];

	if (typeof visibleField === "string" && visibleField !== "") {
		let splitList = visibleField.split(/\|\|/);
		if (splitList.length > 1) {
			for (const element of splitList) {
				let tempList = element.split(/&&/);
				parsedRules.push(tempList);
			}
		} else if (visibleField.includes("&&")) {
			parsedRules.push(visibleField.split(/&&/));
		} else {
			let tempArray = [ visibleField ];
			parsedRules.push(tempArray);
		}
	}

	return removeBrackets(parsedRules);
};

const extractItemIdFromRule = (cleanRule, question) => {
	const updatedQuestion = cloneDeep(question);
	const openingParenthesisIndex = cleanRule.indexOf("(");
	if (openingParenthesisIndex !== -1) {
		const substringStartIndex = openingParenthesisIndex + 1;
		const closingParenthesisIndex = cleanRule.indexOf(")", substringStartIndex);
		if (closingParenthesisIndex !== -1) {
			updatedQuestion.itemId = cleanRule.substring(substringStartIndex, closingParenthesisIndex);
		}
	}

	return updatedQuestion;
};

const removeBrackets = rules => {
	for (const ruleSet of rules) {
		for (let i = 0; i < ruleSet.length; i++) {
			if (ruleSet[i].includes("{{")) {
				ruleSet[i] = ruleSet[i].replace(/{{/, "");
			}
			if (ruleSet[i].includes("}}")) {
				ruleSet[i] = ruleSet[i].replace(/}}/, "");
			}
		}
	}

	return rules;
};
